export default __webpack_public_path__ + "static/media/RightSpark.f69c7c79.svg";